













import { computed, defineComponent } from '@vue/composition-api';
import { bbox } from '@turf/turf';
import { createLayers } from '@/components/map/mapUtils';
import MglMap from '@/components/map/MglMap.vue';
import { Area } from '@/store/types';

export default defineComponent({
	components: {
		MglMap,
	},
	emits: ['back', 'submit'],
	props: {
		area: {
			type: Object as () => Area,
			required: true,
		},
		loading: {
			type: Boolean,
		},
	},
	setup(props) {
		const layers = computed(() =>
			createLayers({
				areas: [props.area as Area],
				polygon: true,
			})
		);

		return {
			mapBounds: props.area ? bbox(props.area) : null,
			layers,
		};
	},
});
